function getProductData(product) {
    const productDataEle = product.querySelector('[data-tracking-product]')
    const productData = JSON.parse(productDataEle.dataset.trackingProduct);
    const { sku, title, vendor, product_type, price } = productData;
    const position = JSON.parse(productDataEle.dataset.algoliaPosition)
    let productType = product_type
    if (product_type === "") {
        let subtypes = productData.named_tags['Product Subtype'] || productData.named_tags['Product Type'] || "";
        if (typeof subtypes !== "string") {
            subtypes = subtypes.join(' / ')
        }
        productType = subtypes.trim()
    }
    const collectionDataEle = document.querySelector('[data-tracking-collection]');
    const collectionData = JSON.parse(collectionDataEle.dataset.trackingCollection);
    const { title: collectionTitle, handle: collectionHandle } = collectionData

    const item = {
        item_id: sku,
        item_name: title,
        affiliation: Shopify.shop,
        currency: Shopify.currency.active,
        index: position,
        item_brand: vendor,
        item_category: productType,
        item_list_id: collectionHandle,
        item_list_name: collectionTitle,
        price: trackingFormatPrice(price, 1),
        quantity: 1
    }
    return item;
}

function pushToDataLayer(eventName, data) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: eventName,
        ecommerce: {
            items: data
        }
    });
}

function createCollectionObserver() {

    function collectionObserverCallback(entries, observer) {
        const queue = [];
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            queue.push(getProductData(entry.target))
            observer.unobserve(entry.target)
        })
        if (queue.length === 0) return
        pushToDataLayer("view_item_list", queue)
    }

    const collectionObserverOptions = {
        threshold: 0.8
    };

    return new IntersectionObserver(collectionObserverCallback, collectionObserverOptions)

}

function handleProductClick(product) {
    const data = getProductData(product);
    pushToDataLayer("select_item", [data])
}

function initCollectionTracking() {
    const collectionObserver = createCollectionObserver();

    const products = document.querySelectorAll('.ais-Hits-item');
    products.forEach(product => {
        collectionObserver.observe(product)
        product.addEventListener('click', () => handleProductClick(product))
    })

}

window.addEventListener('load', () => {
    initCollectionTracking();
})
